export function getImageBySize(variantsArray, size) {
  for (const url of variantsArray) {
    if (url.includes(`/${size}`)) {
      return url
    }
  }

  return null
}
